import toRouterHydrator from '@/js/common/Domain/Hydrator/toRouter';
import toRouterHotelHydrator from '@/js/common/Domain/Hydrator/toRouterHotel';
import searchSessionService from '@/js/common/Domain/Service/search/searchSession';
import tourCriteriaHotelService from '@/js/common/Domain/Service/tourCriteriaHotel';
import filterTourProductsByAdditionalFilters from '@/js/common/Service/hotelPage/filterTourProductsByAdditionalFilters';
import groupProductsByCriterias from '@/js/common/Domain/Service/groupProductsByCriterias';
import { productTypes } from '@fr/constants';
import TourProductsSortedHotelRepository from '../../components/TourProductsSortedHotelRepository';

export default {
    lessPlaces() {
        const syncTourProducts = this.get('syncTourProducts');
        return (syncTourProducts && syncTourProducts.at(0) && syncTourProducts.at(0).get('product')?.get('lessPlaces'));
    },
    subscribe: {
        deps: ['subscribeState'],
        get(subscribeState) {
            return subscribeState;
        },
        set(value) {
            return { subscribeState: value };
        },
    },

    syncTourProductsWithIsExclusive: {
        deps: ['syncTourProducts'],
        get(syncTourProducts) {
            if (!syncTourProducts?.length) return [];
            const syncTourProductsSorted = new TourProductsSortedHotelRepository(syncTourProducts.models, this);
            const groupedSyncTourProducts = groupProductsByCriterias(syncTourProductsSorted);
            this.calculateIsExclusive(groupedSyncTourProducts, syncTourProducts || []);
            return syncTourProductsSorted;
        },
    },

    syncTourProductsOnSelectedDate: {
        deps: ['syncTourProductsWithIsExclusive', 'filterCriteria'],
        get(syncTourProductsWithIsExclusive, filterCriteria) {
            const date = filterCriteria.get('selectedTabDate');
            const syncProducts = new TourProductsSortedHotelRepository(syncTourProductsWithIsExclusive.models, this);
            const syncProductsByDate = this.filterTourProductsByDate(syncProducts, date);
            return new TourProductsSortedHotelRepository(syncProductsByDate, this);
        },
    },

    filteredTourProductsAll: {
        deps: ['filterCriteria', 'syncTourProductsWithIsExclusive'],
        get(filterCriteria, syncTourProductsWithIsExclusive) {
            if (!syncTourProductsWithIsExclusive?.length) {
                return [];
            }
            const filterTourProductsByAdditionalFiltersData = filterTourProductsByAdditionalFilters(filterCriteria, syncTourProductsWithIsExclusive.models);
            return new TourProductsSortedHotelRepository(filterTourProductsByAdditionalFiltersData, this);
        },
    },

    filteredTourProducts: {
        deps: ['filteredTourProductsAll'],
        get(filteredTourProductsAll) {
            const date = this.get('filterCriteria').get('selectedTabDate');
            const filteredTourProductsByDate = this.filterTourProductsByDate(filteredTourProductsAll, date);
            return new TourProductsSortedHotelRepository(filteredTourProductsByDate, this);
        },
    },

    similarHotelsUrl() {
        const tourCriteria = this.get('searchData');
        const params = toRouterHydrator(tourCriteria);

        delete (params.priceFrom);
        delete (params.priceTo);
        delete (params.hotels);
        delete (params.meal);

        return `/search#?${$.param(params)}`;
    },
    isRegion() {
        const departureCity = this.get('searchData').get('departureCity');

        return !!(departureCity && departureCity.get('id') > 2);
    },

    hotTour() {
        return false;
    },

    minPriceTourProduct: {
        deps: ['filteredTourProducts'],
        get(tourProducts) {
            if (!tourProducts?.length) {
                return null;
            }

            return tourProducts.min((tourProduct) => tourProduct.get('product')?.get('priceWithOilTax') || tourProduct.get('product').get('price'));
        },
    },
    minPrice: {
        deps: ['minPriceTourProduct'],
        get(minPriceTourProduct) {
            if (minPriceTourProduct) {
                return minPriceTourProduct.get('product')?.get('priceWithOilTax')
                    || minPriceTourProduct.get('product').get('price');
            }
            return null;
        },
    },
    minPricePerPerson() {
        const tourProducts = this.get('filteredTourProducts');
        let touristGroup;
        let numOfTourists;
        let minPrice;

        if (tourProducts && tourProducts.length) {
            const firstProduct = tourProducts.at(0);
            const product = firstProduct.get('product');
            touristGroup = product.get('touristGroup');
            numOfTourists = parseInt(touristGroup.adults, 10) + parseInt(touristGroup.kids, 10) + (touristGroup.infants ? parseInt(touristGroup.infants, 10) : 0);
            minPrice = this.get('minPrice');

            return Math.round(minPrice / numOfTourists);
        }
        return false;
    },
    minPricePerPersonOutput() {
        return this.get('minPricePerPerson') ? this.get('minPricePerPerson').formatNumber() : false;
    },
    pageIncAvaliable: {
        deps: ['numOfTourPerPage', 'pageNumber', 'filteredTourProductsWithSimilarTours'],
        get(numOfTourPerPage, pageNumber, filteredTourProductsWithSimilarTours) {
            const tourProducts = filteredTourProductsWithSimilarTours;
            let maxPages;

            if (tourProducts && tourProducts.length) {
                maxPages = Math.ceil(tourProducts.length / numOfTourPerPage);
                return pageNumber < maxPages;
            }
            return false;
        },
    },
    filteredTourProductLength() {
        return this.get('filteredTourProducts').length;
    },
    toursLost() {
        return this.get('filteredTourProductsWithSimilarTours').length - this.get('pageNumber') * this.get('numOfTourPerPage');
    },
    toutLostInCollection() {
        return this.get('toursLost') > this.get('numOfTourPerPage') ? this.get('numOfTourPerPage') : this.get('toursLost');
    },
    toutLostInCollectionBool() {
        return this.get('toursLost') > this.get('numOfTourPerPage');
    },
    fromCityLabel() {
        if (this.get('searchData').get('departureCity') !== null) {
            return this.get('searchData').get('departureCity').get('name');
        }
        return false;
    },
    toCountryLabel() {
        if (this.get('searchData').get('countries') !== null) {
            return this.get('searchData').get('countries').pluck('name').slice(0, 3)
                .join(', ');
        }
        return false;
    },
    resortsLabel() {
        if (this.get('searchData').get('resorts') !== null && this.get('searchData').get('resorts').length) {
            return this.get('searchData').get('resorts').pluck('name').slice(0, 4)
                .join(', ');
        }
        return false;
    },
    dateLabel() {
        let from;
        let
            to;
        if (this.get('searchData').get('checkInDateRange') !== null) {
            from = this.get('searchData').get('checkInDateRange').get('from');
            to = this.get('searchData').get('checkInDateRange').get('to');
            return from.getTime() !== to.getTime() ? `${$.datepicker.formatDate('dd.mm', from)} &mdash; ${$.datepicker.formatDate('dd.mm', to)}` : $.datepicker.formatDate('dd.mm', from);
        }
        return false;
    },
    nightsLabelOriginal() {
        let from;
        let
            to;
        if (this.get('searchData').get('nightRange') !== null) {
            from = this.get('searchData').get('nightRange').get('from');
            to = this.get('searchData').get('nightRange').get('to');

            return from !== to ? (`от ${from} до ${to} ноч${to.wordEnding('ь;и;ей')}`) : (`${to} ноч${to.wordEnding('ь;и;ей')}`);
        }
        return false;
    },
    nightsLabel() {
        let from;
        let to;
        const nightsChanged = _.contains(tourCriteriaHotelService.getTourCriteriaChangedFields(), 'nightRange');

        if (this.get('searchData').get('nightRange') !== null && nightsChanged) {
            from = this.get('searchData').get('nightRange').get('from');
            to = this.get('searchData').get('nightRange').get('to');
            return from !== to ? (`от ${from} до ${to} ноч${to.wordEnding('ь;и;ей')}`) : (`${to} ноч${to.wordEnding('ь;и;ей')}`);
        }
        return false;
    },
    budgetLabel() {
        let from;
        let to;
        const budgetChanged = _.contains(tourCriteriaHotelService.getTourCriteriaChangedFields(), 'priceRange');

        if (this.get('searchData').get('priceRange') !== null && budgetChanged) {
            from = this.get('searchData').get('priceRange').get('from');
            to = this.get('searchData').get('priceRange').get('to');
            return from !== to ? (`${from.formatNumber()}<span class="rubl"> ₽</span> - ${to.formatNumber()} <span class="rubl"> ₽</span>`) : (`${from.formatNumber()}<span class="rubl"> ₽</span>`);
        }
        return false;
    },
    hotelCategoriesLabel() {
        if (this.get('searchData').get('hotelCategories') !== null && this.get('searchData').get('hotelCategories').length) {
            return this.get('searchData').get('hotelCategories').pluck('name').join(', ');
        }
        return false;
    },
    postFiltersSelected() {
        const filterCriteria = this.get('filterCriteria');
        return filterCriteria.get('operators')?.length || filterCriteria.get('meals')?.length || filterCriteria.get('productType') !== productTypes.ALL || filterCriteria.get('isExclusive');
    },
    preFiltersSelected() {
        return this.get('warrantedFilterSelected') || this.get('mealFilterSelected');
    },
    warrantedFilterSelected() {
        return !!this.get('searchData').get('warranted');
    },
    mealFilterSelected() {
        return !!(this.get('searchData').get('meals')?.length);
    },
    adults() {
        if (this.get('searchData').get('touristGroup') !== null) {
            return this.get('searchData').get('touristGroup').get('adults');
        }
        return false;
    },
    kids() {
        if (this.get('searchData').get('touristGroup') !== null) {
            return this.get('searchData').get('touristGroup').get('kids');
        }
        return false;
    },
    infants() {
        let infants;
        const touristGroup = this.get('searchData').get('touristGroup');
        if (touristGroup !== null) {
            infants = touristGroup.get('infants');
            return infants || 0;
        }
        return false;
    },
    numOfTourProductsFound() {
        const tourProducts = this.get('syncTourProducts');
        return tourProducts?.length || false;
    },
    numOfTourProductsFiltered() {
        if (this.get('filteredTourProducts') !== null) {
            return this.get('filteredTourProducts').length;
        }
        return false;
    },

    minPriceSyncTourProduct: {
        deps: ['syncTourProducts', 'filterCriteria'],
        get(tourProducts, filterCriteria) {
            if (!tourProducts?.length) {
                return false;
            }

            const selectedProductType = filterCriteria.get('productType') === productTypes.ALL ? productTypes.TOUR_OFFER : filterCriteria.get('productType');
            const filteredProducts = this.filterTourProductsByProductTypeWithTourPriority(tourProducts.models, selectedProductType);

            const products = filteredProducts?.length ? filteredProducts : tourProducts;
            const minPriceProduct = _.min(products.models, (tourProduct) => tourProduct?.get('product')?.get('priceWithOilTax') ?? tourProduct?.get('product')?.get('price'));

            return minPriceProduct === Infinity ? false : minPriceProduct;
        },
    },
    minPriceSyncTourProducts: {
        deps: ['minPriceSyncTourProduct'],
        get(minPriceSyncTourProduct) {
            if (!minPriceSyncTourProduct) {
                return false;
            }

            return minPriceSyncTourProduct?.get('product')?.get('priceWithOilTax')
                ?? minPriceSyncTourProduct?.get('product')?.get('price');
        },
    },
    minPriceSyncTourProductsOilTax: {
        deps: ['minPriceSyncTourProduct'],
        get(minPriceSyncTourProduct) {
            if (!minPriceSyncTourProduct) {
                return false;
            }

            return minPriceSyncTourProduct?.get('product')?.get('oilTax')
                ?? minPriceSyncTourProduct?.get('product')?.get('price');
        },
    },
    minPriceAsyncTourProduct() {
        const tourProducts = this.get('asyncTourProducts');
        let minPrice = Infinity;
        let minPriceTourProduct;

        if (tourProducts && tourProducts.length) {
            tourProducts.each((tourProduct) => {
                const price = tourProduct.get('tour').get('price');
                if (price < minPrice) {
                    minPrice = price;
                    minPriceTourProduct = tourProduct;
                }
            });
            return minPriceTourProduct;
        }
        return false;
    },
    newResultLowerPriceTourProductsFound() {
        let priceDifference;
        const minPriceSyncTourProduct = this.get('minPriceSyncTourProduct');
        const minPriceAsyncTourProduct = this.get('minPriceAsyncTourProduct');
        const minPriceSync = minPriceSyncTourProduct
            ? minPriceSyncTourProduct.get('product')?.get('price')
            : null;
        const minPriceAsync = minPriceAsyncTourProduct
            ? minPriceAsyncTourProduct.get('product')?.get('price')
            : null;

        if (minPriceSync > 0 && minPriceAsync > 0 && minPriceAsync <= minPriceSync - 1000) {
            priceDifference = minPriceSync - minPriceAsync;
            return priceDifference;
        }
        return false;
    },
    additionalTourProductsFound() {
        let newTours;
        const syncTourProducts = this.get('syncTourProducts');
        const asyncTourProducts = this.get('asyncTourProducts');

        if (syncTourProducts !== null && asyncTourProducts !== null) {
            newTours = asyncTourProducts.length - syncTourProducts.length;
            if (newTours > 0) {
                return newTours;
            }
            return false;
        }
        return false;
    },
    departureCityName() {
        let departureCityName = '';
        if (this.get('searchData').get('departureCity') && this.get('searchData').get('departureCity').get('name')) {
            departureCityName = this.get('searchData').get('departureCity').get('name');
        }
        return departureCityName;
    },
};